import { render } from "./DateAndTimeRange.vue?vue&type=template&id=8e1be2d6"
import script from "./DateAndTimeRange.vue?vue&type=script&lang=js"
export * from "./DateAndTimeRange.vue?vue&type=script&lang=js"
script.render = render

export default script